module.exports = __webpack_public_path__ + "static/img/aboutUS_Designplay.2195a66.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/img1/aboutUS_Designplay.png
// module id = zvqr
// module chunks = 1